import React from 'react';
import { useNavigate } from 'react-router-dom';

function HakkimizdaPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-[#1e5a8e] py-6 px-4 shadow-md">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <button onClick={() => navigate('/')} className="text-white hover:text-[#26c6da] transition-colors">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <h1 className="text-2xl md:text-3xl font-bold text-white">Hakkımızda</h1>
          <div className="w-6"></div>
        </div>
      </header>

      {/* Content */}
      <div className="max-w-5xl mx-auto py-12 px-4">
        <div className="bg-white rounded-lg shadow-md p-8 space-y-8">
          <section>
            <h2 className="text-3xl font-bold text-[#1e5a8e] mb-6">Meksa Yatırım Hakkında</h2>
            <p className="text-gray-600 leading-relaxed">
              28 Haziran 1990 yılında kurulan Meksa Menkul Değerler Ticareti A.Ş. 1998 yılında Meksa Yatırım Menkul 
              Değerler A.Ş. ünvanını almıştır. Borsa İstanbul'da faaliyet gösteren önde gelen aracı kurumlardan biri olan 
              Meksa Yatırım yurtiçinde 11 şube ve irtibat bürosu ile bireysel ve kurumsal müşterilerine kapsamlı sermaye 
              piyasaları aracılık hizmetleri sunmaktadır.
            </p>
          </section>

          <section>
            <h3 className="text-2xl font-bold text-gray-700 mb-4">Yönetim Kurulu</h3>
            <div className="grid md:grid-cols-2 gap-6">
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-bold text-[#1e5a8e]">Rıza Kaan FERHATOĞLU</h4>
                <p className="text-gray-600">Yönetim Kurulu Başkanı</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-bold text-[#1e5a8e]">Vesile ŞARLIOĞLU</h4>
                <p className="text-gray-600">Yönetim Kurulu Başkan Vekili</p>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-bold text-[#1e5a8e]">Mert YILMAZ</h4>
                <p className="text-gray-600">Yönetim Kurulu Üyesi</p>
              </div>
            </div>
          </section>

          <section>
            <h3 className="text-2xl font-bold text-gray-700 mb-4">BIST Borsası Üyelikleri</h3>
            <ul className="list-disc list-inside space-y-2 text-gray-600">
              <li>Hisse Senetleri Piyasası</li>
              <li>Tahvil ve Bono Piyasası Kesin Alım Satım Pazarı</li>
              <li>Tahvil ve Bono Piyasası Repo/Ters Repo Pazarı</li>
              <li>Uluslararası Pazar Depo Sertifikaları Piyasası</li>
            </ul>
          </section>

          <section className="bg-[#26c6da] bg-opacity-10 p-6 rounded-lg">
            <h3 className="text-xl font-bold text-[#1e5a8e] mb-3">Yetki Belgelerimiz</h3>
            <p className="text-gray-600">
              Şirketimiz Sermaye Piyasası Kurulu'nun 30.11.2015 tarih, 32992422-200.E.12934 sayılı izin yazısı gereği, 
              <span className="font-bold"> "Geniş Yetkili Aracı Kurum"</span> olarak faaliyet göstermektedir.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default HakkimizdaPage;
